export default "__VITE_ASSET__CrfVmnYQ__"